
import { Component, Vue } from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import { IOdemeIslemi } from "@/plugins/uyap-plugin/uyap/OdemeIslemiSorgulama";
import { Task } from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import { TaskTuru } from "@/plugins/uyap-plugin/enum/TaskTuru";
import MakbuzController from "@/plugins/uyap-plugin/makbuz/MakbuzController";
import { ProgramPaths } from "@/enum/ProgramPaths";
import Loading from "@/components/Loading.vue";

@Component({
  components: { Loading, Dates },
})
export default class MakbuzIndirList extends Vue {
  headers = [
    {
      text: "Dosya Esas Numarası",
      align: "start",
      sortable: true,
      value: "dosyaNo",
    },
    { text: "Birim Adı", value: "birimAdi" },
    { text: "Dosya Turu", value: "dosyaTurKod" },
    { text: "Tutar", value: "tutar" },
    { text: "Durum", value: "durum" },
    { text: "İşlem Tarihi", value: "uyapIslemTarihi" },
    { text: "Taraflar", value: "taraflar" },
    {
      text: "İşlemler",
      value: "actions",
      width: 50,
      align: "center",
      sortable: false,
    },
  ];
  data = {
    baslangicTarihi: "",
    bitisTarihi: "",
  };
  onFly = false;
  taskCreated = false;
  items: IOdemeIslemi[] = [];
  selectedDateFilter: null;
  unfilteredItems: IOdemeIslemi[] = [];
  selectedItems: IOdemeIslemi[] = [];
  dosyaTurleri: string[] = [];
  selectedDosyaTuruFilter: string = "";
  sadeceBasarililarFilter: boolean = false;
  tarafListesi: string[] = [];
  selectedTarafFilter: string = "";


  async fillRows() {
    try{
      this.onFly = true;
      const timeDiff = Math.abs(
          new Date(this.data.bitisTarihi).getTime() -
          new Date(this.data.baslangicTarihi).getTime()
      );
      const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      if (diffDays <= 30) {
        let response = await this.$uyap.OdemeIslemiSorgulama().run({
          baslangicTarihi: this.$helper.changeUyapDateFormat(
              this.data.baslangicTarihi
          ),
          bitisTarihi: this.$helper.changeUyapDateFormat(this.data.bitisTarihi),
        });
        this.items = response;
        this.items = this.items.filter(
            (item: IOdemeIslemi) => typeof item.birimAdi != "undefined"
        );
        console.log("items", this.items);
        this.unfilteredItems = Object.assign([], this.items);

        // Dosya türlerini topla
        this.dosyaTurleri = [];
        this.items.forEach((x:any) => {
          let exists = this.dosyaTurleri.find((y:any) => y == x.tutar);
          if (!exists) this.dosyaTurleri.push(x.tutar);
        });

        // Tarafları topla
        this.tarafListesi = [];
        this.items.forEach((item: any) => {
          if (item.dosyaTaraflari && item.dosyaTaraflari.length > 0) {
            item.dosyaTaraflari.forEach((taraf: any) => {
              const tarafAdi = (taraf.isim + " " + (taraf.soyad || "")).trim();
              if (!this.tarafListesi.includes(tarafAdi)) {
                this.tarafListesi.push(tarafAdi);
              }
            });
          }
        });
        this.tarafListesi.sort(); // Alfabetik sırala

        this.filterDosyaTurleri();
      } else {
        this.$toast.error("Tarih aralığını 30 günden fazla olamaz.");
      }
    }catch (e) {
      this.$toast.error(e.message);
    }finally {
      this.onFly = false;
    }

  }
  get selectedItemsCheckbox() {
    return this.selectedItems.length > 0;
  }

  filterDosyaTurleri() {
    let filteredItems = Object.assign([], this.unfilteredItems);

    // Başarılı filtresi
    if (this.sadeceBasarililarFilter) {
      filteredItems = filteredItems.filter(
          (item: any) => item.durum == "Başarılı"
      );
    }

    // Dosya türü filtresi
    if (this.selectedDosyaTuruFilter !== "") {
      filteredItems = filteredItems.filter(
          (item: any) => item.tutar == this.selectedDosyaTuruFilter
      );
    }

    // Taraf filtresi
    if (this.selectedTarafFilter !== "") {
      filteredItems = filteredItems.filter((item: any) => {
        if (item.dosyaTaraflari && item.dosyaTaraflari.length > 0) {
          return item.dosyaTaraflari.some((taraf: any) => {
            const tarafAdi = (taraf.isim + " " + (taraf.soyad || "")).trim();
            return tarafAdi === this.selectedTarafFilter;
          });
        }
        return false;
      });
    }

    this.items = filteredItems;
  }

  async filterLastWeek() {
    await this.filterByDateMinus(7, 0);
  }

  async filterLastMonth() {
    await this.filterByDateMinus(30, 0);
  }

  async filterLast2Month() {
    await this.filterByDateMinus(60, 30);
  }

  async filterByDateMinus(startDayCount: number, finishDayCount: number) {
    let bugun: Date = new Date();
    let oncekiTarih: Date = new Date(bugun);
    oncekiTarih.setDate(bugun.getDate() - finishDayCount);
    this.data.bitisTarihi = oncekiTarih.toISOString().substr(0, 10);
    oncekiTarih = new Date(bugun);
    oncekiTarih.setDate(bugun.getDate() - startDayCount);
    this.data.baslangicTarihi = oncekiTarih.toISOString().substr(0, 10);
    await this.fillRows();
  }

  async createTask() {
    try {
      this.onFly = true;
      if (this.selectedItems.length == 0)
        throw new Error("İndirilecek makbuz/lar seçilmedi.");
      let tasks: Array<Task> = [];
      for (const item of this.selectedItems) {
        let task: Task = new Task();
        task.dosya_esas_no = item.dosyaNo ?? "";
        task.birim_adi = item.birimAdi;
        task.task_type_id = TaskTuru.makbuz_indir;
        task.data = item;
        tasks.push(task);
      }
      await this.$store.dispatch("postTasks", tasks);
      this.taskCreated = true;
    } catch (e) {
      this.$toast.error(e.message);
    } finally {
      this.onFly = false;
    }
  }

  async downloadSelected(item: IOdemeIslemi) {
    try {
      let fileName = item.dosyaNo + " makbuz (" + item.uyapId + ")";
      await MakbuzController.download(item.uyapId, item.uyapIslemTur, fileName);
    } catch (e) {
      this.$toast.error(e.message);
    }
  }

  sifirla() {
    this.selectedItems = [];
    this.data = {
      baslangicTarihi: "",
      bitisTarihi: "",
    };
    this.taskCreated = false;
    this.selectedTarafFilter = "";
    this.selectedDosyaTuruFilter = "";
    this.sadeceBasarililarFilter = false;
  }

  selectAllToggle() {
    let secilebilirler = this.items.filter(
        (item: any) => item.durum == "Başarılı"
    );
    if (this.selectedItems.length == secilebilirler.length) {
      this.selectedItems = [];
    } else {
      this.selectedItems = secilebilirler;
    }
  }

  islemlereGit() {
    this.$router.push(ProgramPaths.eicrapro + "/islemler");
  }
}
